import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../../../services/IFilter";

export class TicketApprovalsFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  eventTypeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get eventType():any {
    return this.eventTypeChange.value;
  }
  set eventType(value:any) {
    this.eventTypeChange.next(value);
    this.emitChange("eventTypeName", value);
  }

  eventCategoryChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get eventCategory():any {
    return this.eventCategoryChange.value;
  }
  set eventCategory(value:any) {
    this.eventCategoryChange.next(value);
    this.emitChange("eventCategoryName", value);
  }

  contactGroupChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get contactGroup():any {
    return this.contactGroupChange.value;
  }
  set contactGroup(value:any) {
    this.contactGroupChange.next(value);
    this.emitChange("contactGroupName", value);
  }

  activeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get active():any {
    return this.activeChange.value;
  }
  set active(value:any) {
    this.activeChange.next(value);
    this.emitChange("active", value);
  }

  approvalOrderChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get approvalOrder():any {
    return this.approvalOrderChange.value;
  }
  set approvalOrder(value:any) {
    this.approvalOrderChange.next(value);
    this.emitChange("approvalOrder", value);
  }

  notesChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get notes():any {
    return this.notesChange.value;
  }
  set notes(value:any) {
    this.notesChange.next(value);
    this.emitChange("notes", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.eventCategory && this.eventCategory !== '') {
      params = params.set("eventCategoryName", this.eventCategory);
    }
    if (this.eventType && this.eventType !== '') {
      params = params.set("eventTypeName", this.eventType);
    }
    if (this.contactGroup && this.contactGroup !== '') {
      params = params.set("contactGroupName", this.contactGroup);
    }
    if (this.active && this.active !== '') {
      params = params.set("active", this.active);
    }
    if (this.approvalOrder && this.approvalOrder !== '') {
      params = params.set("approvalOrder", this.approvalOrder);
    }
    if (this.notes && this.notes !== '') {
      params = params.set("notes", this.notes);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.eventCategoryChange.next(props.eventCategory || undefined);
    this.eventTypeChange.next(props.eventType || undefined);
    this.contactGroupChange.next(props.contactGroup || undefined);
    this.activeChange.next(props.active || undefined);
    this.approvalOrderChange.next(props.approvalOrder || undefined);
    this.notesChange.next(props.notes || undefined);
  }

  toObj() {
    let obj:any = {};
    
    obj.companyId = this.companyId;
    obj.name = this.name;
    obj.eventCategory = this.eventCategory;
    obj.eventType = this.eventType;
    obj.contactGroup = this.contactGroup;
    obj.active = this.active;
    obj.approvalOrder = this.approvalOrder;
    obj.notes = this.notes;
  
    return obj;
  }

  public clear():void {
    this.companyId = undefined;
    this.name = undefined;
    this.eventCategory = undefined;
    this.eventType = undefined;
    this.contactGroup = undefined;
    this.active = undefined;
    this.approvalOrder = undefined;
    this.notes = undefined;
  }
}
